import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  CardTitle,
  Col,
  FormGroup,
  Label,
  Row,
  Table,
  Tooltip,
} from "reactstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import CheckboxCollapse from "../../../../components/Common/CheckboxCollapse";
import CustomSelect from "../../../../components/Common/CustomSelect";
import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import SweetAlert from "react-bootstrap-sweetalert";
import { hardCompareArray, showInfoMessage } from "./../../../../helpers/utils";

class MapFields extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: [],
      checked: [],
      options: [
        {
          label: "Don't map this field",
          value: "NO_MAPPED",
        },
      ],
      mapData: {},
      currentTemplate: { label: "Don't use template", value: "NOT_USE_TEMP" },
      platform: {},
      deleteAlert: false,
      updateCurrentTemplate: false,
      loading_status: false,
    };

    this.clearSelectedFields = this.clearSelectedFields.bind(this);
    this.handleClickDeleteTemplate = this.handleClickDeleteTemplate.bind(this);
    this.handleChangeDeleteAlert = this.handleChangeDeleteAlert.bind(this);
    this.handleChangeTemplate = this.handleChangeTemplate.bind(this);
    this.handleSelectValue = this.handleSelectValue.bind(this);
  }

  componentDidMount() { }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { selectedFiles } = this.props;

    if (
      this.props.activeTab < 3 &&
      selectedFiles.length > 0 &&
      selectedFiles[0].name !== prevProps.selectedFiles[0]?.name
    ) {
      let checked = [];
      let selected = [];
      let options = [
        {
          label: "Don't map this field",
          value: "NO_MAPPED",
        },
      ];
      this.props.model.map(item => {
        let check = {};
        check[item] = false;
        checked.push(check);
        options.push({
          label: item,
          value: item,
        });
      });
      this.props.fileData?.headers.map(map => {
        selected.push({
          label: "Don't map this field",
          value: "NO_MAPPED",
        });
      });
      this.setState({
        checked,
        options,
        selected,
        mapData: {},
      });
      this.props.updateMapData({});
    }

    if (this.props.activeTab === 3) {
      if (Object.keys(this.props.mapData).length === 0) {
        this.props.onClickSetNextActive(false);
      } else {
        let checked_active = 0;
        this.state.checked.map(item => {
          for (let [key, value] of Object.entries(item)) {
            if (item[key]) {
              checked_active += 1;
            }
          }
        });
        this.props.onClickSetNextActive(true);
        //this.setState({ activeNext: true });
        /* if (checked_active < 1) {
        //   this.props.onClickSetNextActive(false);
         } */
      }

      if (
        !hardCompareArray(prevProps.model, this.props.model) ||
        !hardCompareArray(prevProps.templates, this.props.templates)
      ) {
        this.clearSelectedFields();
      }
    }

    if (prevProps.sources_list !== this.props.sources_list) {
      let pl = this.generateSources(this.props.sources_list)[0];
      this.setState({
        platform: pl,
      })
      this.props.handleChangePlatform(pl.value)
    }

    if (prevProps.template !== this.props.template) {
      this.setState({ loading_status: true });
      const { template, fileData } = this.props;
      let update_selected = [];

      fileData?.headers.map(map => {
        update_selected.push({
          label: "Don't map this field",
          value: "NO_MAPPED",
        });
      });

      let templateErrors = 0;

      for (let key in template.mapper) {
        let idx = this.props.fileData.headers.findIndex(item => item === key);
        if (idx < 0) {
          templateErrors += 1;
        } else {
          update_selected[idx].label = template.mapper[key];
          update_selected[idx].value = template.mapper[key];
        }
      }

      if (templateErrors > 0) {
        showInfoMessage("This template is not suitable for the current table");
      } else {
        this.setState({
          selected: update_selected,
          mapData: this.props.template.mapper,
        });
        this.props.updateMapData(this.props.template.mapper);
      }
      this.setState({ loading_status: false });
    }

    if (this.state.updateCurrentTemplate !== prevState.updateCurrentTemplate) {
      this.setState({ updateCurrentTemplate: false });
    }
  }

  componentWillUnmount() {
    this.props.handleSaveTemplateStatus(false);
    this.handleSetDefaultState();
  }

  clearSelectedFields = () => {
    let checked = [];
    let options = [
      {
        label: "Don't map this field",
        value: "NO_MAPPED",
      },
    ];
    let selected = [];
    this.props.model.map(item => {
      let check = {};
      check[item] = false;
      checked.push(check);
      options.push({
        label: item,
        value: item,
      });
    });

    this.props.fileData?.headers.map(map => {
      selected.push({
        label: "Don't map this field",
        value: "NO_MAPPED",
      });
    });

    let currentTemplate = {
      label: "Don't use template",
      value: "NOT_USE_TEMP",
    };

    this.setState({
      checked,
      options,
      selected,
      mapData: {},
      updateCurrentTemplate: true,
      currentTemplate,
    });
    this.props.updateMapData({});
  };

  handleSetDefaultState = () => {
    this.setState({
      selected: [],
      checked: [],
      options: [],
      mapData: {},
      platform: {},
      currentTemplate: { label: "Don't use template", value: "NOT_USE_TEMP" },
    });
  };

  handleChangeCheckbox = (idx, status, item, select) => {
    let map_checked = this.state.checked;
    let map = this.state.mapData;
    let new_map = {};

    map_checked[idx][item] = status;

    this.props.model.map(i => {
      map_checked.map(check => {
        for (let [key, value] of Object.entries(check)) {
          let change_selected = status ? select.value : map[key];
          if (item == key && value) {
            new_map[key] =
              select.value === "NO_MAPPED" ? select.value : change_selected;
          } else if (item !== key && value) {
            new_map[key] = map[key];
          }
        }
      });
    });
    this.setState({ checked: map_checked, mapData: new_map });
    //this.props.updateMapData(new_map);
  };

  handleSelectValue = (e, key, item) => {
    const selected = this.state.selected;
    const map = this.state.mapData;

    //if (this.state.checked[key][item]) {
    map[item] = e.value;
    //}

    selected[key] = e;

    this.setState({ selected: selected, mapData: map });
    this.props.updateMapData(map);
  };

  handleChangeSource = item => {
    this.setState({
      platform: item,
    });
    return this.props.handleChangePlatform(item.value)
  }

  handleChangeTemplate = item => {
    if (item.value === "NOT_USE_TEMP") {
      let checked = [];
      let options = [
        {
          label: "Don't map this field",
          value: "NO_MAPPED",
        },
      ];
      let selected = [];
      this.props.model.map(item => {
        let check = {};
        check[item] = false;
        checked.push(check);
        options.push({
          label: item,
          value: item,
        });
      });

      this.props.fileData?.headers.map(map => {
        selected.push({
          label: "Don't map this field",
          value: "NO_MAPPED",
        });
      });
      this.props.uploadTemplateError(false);
      this.props.updateMapData({});
      this.setState({
        checked,
        options,
        selected,
        currentTemplate: item,
        mapData: {},
      });
    } else {
      this.setState({
        currentTemplate: item,
      });
      this.props.getMapperTemplate(item.value);
    }
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  handleClickDeleteTemplate = () => {
    const data = {
      onConfirm: () => {
        this.props.deleteMapperTemplate(this.state.currentTemplate.value, {
          content_type: this.props.modelData.id,
        });
        this.setState({ deleteAlert: !this.state.deleteAlert });
      },
    };
    this.setState({
      deleteAlertData: data,
      deleteAlert: !this.state.deleteAlert,
    });
  };

  generateSources = sources => {
    let options = [];
    sources.map(item => {
      options.push({
        label: item.name,
        value: item.name,
      });
    });
    return options;
  };

  render() {
    const animatedComponents = makeAnimated();

    const generateTemplate = templates => {
      let options = [{ label: "Don't use template", value: "NOT_USE_TEMP" }];
      templates.map(item => {
        options.push({
          label: item.name,
          value: item.id,
        });
      });
      return options;
    };

    return (
      <React.Fragment>
        {this.state.deleteAlert && (
          <SweetAlert
            showCancel
            confirmBtnText="Delete"
            cancelBtnText="Cancel"
            confirmBtnBsStyle="danger"
            title="Delete template"
            onCancel={() =>
              this.setState({
                deleteAlert: !this.state.deleteAlert,
              })
            }
            onConfirm={this.state.deleteAlertData.onConfirm}
          >
            <p>
              Are you sure want to delete
              <strong>{this.props.template.name}</strong> template?
            </p>
          </SweetAlert>
        )}

        <AvForm>
          <CardTitle className="h4">Upload widget: Map fields</CardTitle>
          <p className="card-title-desc">
            Select the CSV fields to import, then set how you would like these
            converted to fields in JIRA. You can optionally map field values on
            the next screen. You can also choose an existing template or create
            a new one.
          </p>

          {this.props.permissions?.["view_mappertemplatemodel"] && (
            <Row>
              <Col md="6">
                <FormGroup className="mb-3">
                  <Label htmlFor="">Templates:</Label>
                  {!this.state.updateCurrentTemplate && (
                    <CustomSelect
                      name={"template"}
                      options={generateTemplate(this.props.templates)}
                      defaultValue={this.state.currentTemplate}
                      placeholder="Templates..."
                      onChange={val => this.handleChangeTemplate(val)}
                      classNamePrefix="select2-selection"
                      isLoading={this.state.loading_status}
                    />
                  )}
                </FormGroup>
              </Col>
              {this.props.sources_list && !['3', 3].includes(this.props.modelData.id) && (
                <Col md="6">
                  <FormGroup className="mb-3">
                    <Label htmlFor="">Platform:</Label>
                    <CustomSelect
                      name={"platform"}
                      options={this.generateSources(this.props.sources_list)}
                      defaultValue={this.generateSources(this.props.sources_list)[0]}
                      placeholder="Platform..."
                      onChange={val => this.handleChangeSource(val)}
                      classNamePrefix="select2-selection"
                      isLoading={this.props.sources_loading}
                    // isLoading={this.state.loading_status}
                    />
                  </FormGroup>
                </Col>
              )}
              <Col md={4}>
                {this.state.currentTemplate.value !== "NOT_USE_TEMP" && (
                  <div style={{ display: "flex" }}>
                    <div style={{ display: "none" }}>
                      <button
                        type="button"
                        style={{
                          marginTop: 27,
                          padding: "9px",
                          marginRight: "5px ",
                        }}
                        className="btn btn-primary  btn-sm"
                        onClick={() => this.handleClickDeleteTemplate()}
                      >
                        <span>Update template</span>
                      </button>
                    </div>
                    <div>
                      <button
                        type="button"
                        style={{ marginTop: 27 }}
                        className="btn btn-danger  btn-sm"
                        onClick={() => this.handleClickDeleteTemplate()}
                      >
                        <i className="mdi mdi-trash-can d-block font-size-18" />
                      </button>
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          )}

          <Table striped className="mb-0">
            <thead>
              <tr>
                <th style={{ width: "50%" }}>File field</th>
                <th>CRM Field</th>
                <th style={{ width: "20%" }}>Map field value</th>
              </tr>
            </thead>
            <tbody>
              {this.props.fileData !== null &&
                this.props.fileData?.headers.map((item, key) => (
                  <tr style={{ verticalAlign: "middle" }} key={key}>
                    <td>{item}</td>
                    <td>
                      <FormGroup className="mt-lg-0 templating-select select2-container">
                        <Select
                          defaultValue={[
                            {
                              label: "Don't map this field",
                              value: "NO_MAPPED",
                            },
                          ]}
                          value={this.state.selected[key]}
                          onChange={e => this.handleSelectValue(e, key, item)}
                          options={this.state.options}
                          classNamePrefix="select2-selection"
                          components={animatedComponents}
                          closeMenuOnSelect
                          isLoading={this.state.loading_status}
                        />
                      </FormGroup>
                    </td>
                    <td>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        style={{ verticalAlign: "middle" }}
                        checked={this.state.checked[key]?.[item] || false}
                        onChange={e =>
                          this.handleChangeCheckbox(
                            key,
                            e.target.checked,
                            item,
                            this.state.selected[key]
                          )
                        }
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>

          {this.props.permissions?.["add_mappertemplatemodel"] && (
            <Row>
              <Col xl={6}>
                <FormGroup className="mt-4">
                  {!this.state.updateCurrentTemplate && (
                    <CheckboxCollapse
                      id={"template_status"}
                      title="Save as template"
                      defaultChecked={false}
                      onChange={val => this.props.handleSaveTemplateStatus(val)}
                      end
                    >
                      <AvField
                        name={"template_name"}
                        onChange={e =>
                          this.props.handleChangeTemplateName(e.target.value)
                        }
                        value={this.props.templateName}
                        placeholder="Enter template name..."
                        type="text"
                        errorMessage="Template field is required"
                        className="form-control"
                        validate={{
                          required: { value: true },
                        }}
                      />
                    </CheckboxCollapse>
                  )}
                </FormGroup>
              </Col>
            </Row>
          )}
        </AvForm>
      </React.Fragment>
    );
  }
}

MapFields.propTypes = {
  model: PropTypes.any,
  fileData: PropTypes.any,
  updateMapData: PropTypes.func,
  activeTab: PropTypes.node,
  selectedFiles: PropTypes.any,
  files: PropTypes.any,
  success: PropTypes.bool,
  mapData: PropTypes.any,
  modelData: PropTypes.any,
  templates: PropTypes.any,
  prevFile: PropTypes.any,
  template: PropTypes.any,
  saveTemplateStatus: PropTypes.bool,
  templateName: PropTypes.string,
  onClickSetNextActive: PropTypes.func,
  handleSaveTemplateStatus: PropTypes.func,
  handleChangeTemplateName: PropTypes.func,
  getMapperTemplates: PropTypes.func,
  getMapperTemplate: PropTypes.func,
  deleteMapperTemplate: PropTypes.func,
  uploadTemplateError: PropTypes.func,
  permissions: PropTypes.object,
  sources_list: PropTypes.any,
  sources_loading: PropTypes.bool,
  handleChangePlatform: PropTypes.func,
};

export default connect()(MapFields);
